import { lazy } from "react";

export { MODULE_SETTINGS_PATH } from "./module-settings-path";
export const ModuleSettingsPage = lazy(() => import("./module-settings-page"));
